import e from "./contact-channels84.js";
function n(r, a) {
  e(r);
  for (var t = r.length - 1; /\s/.test(r.charAt(t)); )
    t -= 1;
  return r.slice(0, t + 1);
}
export {
  n as default
};
//# sourceMappingURL=contact-channels86.js.map
